import { render, staticRenderFns } from "./PortfolioWidgetRow.vue?vue&type=template&id=37f8cca3&"
import script from "./PortfolioWidgetRow.vue?vue&type=script&lang=js&"
export * from "./PortfolioWidgetRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f8cca3')) {
      api.createRecord('37f8cca3', component.options)
    } else {
      api.reload('37f8cca3', component.options)
    }
    module.hot.accept("./PortfolioWidgetRow.vue?vue&type=template&id=37f8cca3&", function () {
      api.rerender('37f8cca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/PortfolioWidgetRow.vue"
export default component.exports